<template>
    <div>
        <gofix-card classContent="mt-4 mb-2">
            <b-row>
                <b-col md="12">
                    <b-row>
                        <b-col md="4">
                            <gofix-form-dropdown 
                                vLabel="contract_name"
                                label="Town Council" 
                                required
                                show-icon-required
                                :filterable="false" 
                                :class="{ 'form-input--error': $v.CaseObj.contract.$error }" 
                                :disabled="isDisabled"
                                :options="options.contracts" 
                                v-model="$v.CaseObj.contract.$model" 
                                @search="searchContract" 
                                @change="changeContract">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                            <div class="property-dropdown-container">
                                <div class="property-dropdown dropdown-custom-tooltip">
                                    <gofix-form-dropdown 
                                        vLabel="name"
                                        label="Division" 
                                        required
                                        show-icon-required
                                        :filterable="false" 
                                        :class="[
                                            { 'form-input--error':  $v.CaseObj.properties.$error }, 
                                            { 'run-loading small-loading': loading.properties } 
                                        ]" 
                                        :desc="CaseObj && CaseObj.properties ? CaseObj.properties.root_path : ''" 
                                        :disabled="isDisabled" 
                                        :options="options.properties" 
                                        v-model="$v.CaseObj.properties.$model" 
                                        @search="searchProperty" >
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span v-b-tooltip.hover.top :title="option.root_path" v-html="$options.filters.highlightNode(option.root_path, key_search_property || CaseObj.properties)"></span>
                                        </template>
                                    </gofix-form-dropdown>
                                </div>
                                <span @click="modals.properties.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                <ModalProperties 
                                    :disabled="isDisabled"
                                    :contract_id="CaseObj.contract && CaseObj.contract.id ? Number(CaseObj.contract.id) : null" 
                                    :propertySelected="CaseObj.properties ? CaseObj.properties : {}" 
                                    v-model="modals.properties.open" 
                                    @updateData="updateProperty" />
                            </div>
                        </b-col>
                        <b-col md="4">
                            <gofix-form-input label="Recorded By" autocomplete="off" disabled v-model="CaseObj.recorded_by.name"/>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12">
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input-date 
                                        label="Date Reported" 
                                        required 
                                        showIconRequired
                                        :class="{ 'form-input--error': $v.CaseObj.reported_date.$error }" 
                                        :disabled="isDisabled" 
                                        v-model="$v.CaseObj.reported_date.$model">
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="6">
                                    <div class="property-dropdown-container">
                                        <div class="dropdown-custom-tooltip">
                                            <gofix-form-input-time ref="timet" 
                                                label="Time Reported" 
                                                required 
                                                showIconRequired
                                                :class="['caseSelectTime', { 'form-input--error': $v.CaseObj.reported_time.$error }]" 
                                                :disabled="isDisabled" 
                                                v-model="$v.CaseObj.reported_time.$model">
                                            </gofix-form-input-time>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input desc="dd.mm.yyyy" :disabled="true" label="Date Recorded" v-model="CaseObj.recorded_date" autocomplete="off" />
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input :disabled="true" label="Time Recorded" v-model="CaseObj.recorded_date_time" />
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <gofix-form-input 
                                label="Email"
                                type="email" 
                                autocomplete="off" 
                                disabled 
                                class="gofixInputNoMinWidth inputOverFollow"
                                v-model="CaseObj.recorded_by.email" >
                            </gofix-form-input>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </gofix-card>
        <b-row class="card-reduc-margin">
            <b-col md="12">
                <gofix-card class="cardFullHeight" classContent="mb-0" title="Case Info">
                    <b-row>
                        <b-col md="12">
                            <b-row>
                                <b-col md="4">
                                    <div class="property-dropdown-container">
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-properties 
                                                label="Primary location" 
                                                valueFormat="object"  
                                                required
                                                show-icon-required
                                                disableBranchNodes
                                                :class="['gofixInputNoMinWidth text-normal', { 'form-input--error': $v.CaseObj.location.$error }]"
                                                :disabled="isDisabled" 
                                                :desc="CaseObj.location ? CaseObj.location.root_path : ''" 
                                                :property-id="CaseObj.properties ? CaseObj.properties.id : null" 
                                                v-model="$v.CaseObj.location.$model"
                                                @change="changeProperty">
                                            </gofix-form-properties>
                                        </div>
                                        <span @click="showModalPrimaryLocation" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                        <ModalProperties 
                                            :disabled="isDisabled"
                                            :contract_id="CaseObj.contract && CaseObj.contract.id ? Number(CaseObj.contract.id) : null" 
                                            :property_id="CaseObj.properties && CaseObj.properties.id ? Number(CaseObj.properties.id) : null" 
                                            :propertySelected="CaseObj.location ? CaseObj.location : {}" 
                                            v-model="modals.location.open" 
                                            @updateData="updateLocation" />
                                    </div>
                                </b-col>
                                <b-col md="4">
                                    <div class="property-dropdown-container">
                                        <div class="property-dropdown">
                                            <gofix-form-dropdown
                                                label="Avenue Of Feedback"
                                                vLabel="reference_value_text"
                                                required
                                                show-icon-required
                                                class="gofixInputNoMinWidth"
                                                :class="{ 'form-input--error': $v.CaseObj.avenue_of_feedback.$error }" 
                                                :disabled="isDisabled"
                                                :options="options.avenue_of_feedbacks"
                                                v-model="$v.CaseObj.avenue_of_feedback.$model"
                                                @change="changeAvenueOfFeedback"
                                                >
                                            </gofix-form-dropdown>
                                        </div>
                                        <span @click="modals.avenue_of_feedback.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                        <ModalAvenueOfFeedback 
                                            :options="options.avenue_of_feedbacks" 
                                            :valueSelected="CaseObj.avenue_of_feedback" 
                                            v-model="modals.avenue_of_feedback.open" 
                                            @updateData="updateAvenueOfFeedback" 
                                            :disabled="isDisabled"/>
                                    </div>
                                </b-col>
                                <b-col md="4">
                                    <div class="property-dropdown-container">
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-tree 
                                                label="Category" 
                                                required
                                                show-icon-required
                                                disableBranchNodes
                                                valueFormat="object" 
                                                :class="['gofixInputNoMinWidth', { 'form-input--error': $v.CaseObj.service_categories.$error }]" 
                                                :user-value-label-slot="true" 
                                                :disabled="isDisabled" 
                                                :defaultExpandLevel="0"
                                                :normalizer="normalizerServiceCategory" 
                                                :load-options="loadOptionServiceCategory" 
                                                :options="options.service_categories" 
                                                v-model="$v.CaseObj.service_categories.$model"
                                                @select="changeService">
                                                <template slot="gofixTreeSelect:value-label" slot-scope="{ node }">{{ node.raw.name }}</template>
                                            </gofix-form-tree>
                                        </div>
                                        <span @click="modals.service_category.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                        <ModalServiceCategory 
                                            :disabled="isDisabled"
                                            :contract_id="CaseObj.contract && CaseObj.contract.id ? Number(CaseObj.contract.id) : null" 
                                            :service_id="modals.service_category.service_id" 
                                            :serviceSelected="CaseObj.service_categories ? CaseObj.service_categories : {}" 
                                            v-model="modals.service_category.open" 
                                            @updateData="updateServiceCategory" />
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="12">
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Priority"
                                        vLabel="priority"
                                        :filterable="true"
                                        required
                                        show-icon-required
                                        append-to-body
                                        :class="['gofixInputNoMinWidth', { 'form-input--error': $v.CaseObj.sla.$error }]"
                                        :disabled="isDisabled"
                                        :options="options.priority"
                                        v-model="CaseObj.sla">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Person in charge"
                                        vLabel="user_name"
                                        append-to-body
                                        show-icon-required
                                        :required="!CaseObj.team_in_charge_id"
                                        :disabled="isDisabled"
                                        :class="{ 'form-input--error': $v.CaseObj.user.$error }"
                                        v-model="$v.CaseObj.user.$model"
                                        :options="options.users"
                                        @search="searchFmStaff">
                                        <template #gofixInput:dropdown:option="{ user_name, role_name }">
                                                {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                        </template>
                                        <template #gofixInput:dropdown:selected-option="{ user_name, role_name }">
                                            {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="2">
                                    <div class="property-dropdown-container">
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-tree 
                                                label="Nature of Feedback"
                                                valueFormat="object"
                                                required
                                                show-icon-required
                                                user-value-label-slot
                                                class="gofixInputNoMinWidth"
                                                :class="{ 'form-input--error': $v.CaseObj.nature_feedback.$error }"
                                                :disabled="isDisabled"
                                                :normalizer="normalizerNatureFeedBack"
                                                :load-options="loadOptionNatureFeedBack"
                                                :options="options.tree_nature_feedBack"
                                                v-model="$v.CaseObj.nature_feedback.$model"
                                                >
                                                <template slot="gofixTreeSelect:value-label" slot-scope="{ node }">{{ node.raw.name }}</template>
                                            </gofix-form-tree>
                                        </div>
                                        <span @click="modals.nauture_of_feedback.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                        <ModalNatureOfFeedback 
                                            :valDropdown="CaseObj.nature_feedback" 
                                            :contract_id="CaseObj.contract && CaseObj.contract.id ? Number(CaseObj.contract.id) : null" 
                                            :natureSelected="CaseObj.nature_feedback ? CaseObj.nature_feedback : {}" 
                                            v-model="modals.nauture_of_feedback.open" 
                                            @updateData="updateNature" 
                                            :disabled="isDisabled"/>
                                    </div>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input-date 
                                        label="Proposed timeline" 
                                        required 
                                        showIconRequired
                                        :class="{ 'form-input--error': $v.CaseObj.proposed_timeline.$error }" 
                                        :minDate="new Date()"
                                        :disabled="isDisabled" 
                                        v-model="$v.CaseObj.proposed_timeline.$model">
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="12">
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-input-textarea 
                                        label="Other locations" 
                                        class="caseDescTextArea" 
                                        :classTextarea="(isDisabled) ? 'no-drop' : ''" 
                                        :disabled="isDisabled" 
                                        :showClassDisabled="false" 
                                        v-model="CaseObj.other_locations">
                                    </gofix-form-input-textarea>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input-textarea 
                                        label="Description" 
                                        :class="['caseDescTextArea', { 'form-input--error': $v.CaseObj.feedback_detail.$error }]" 
                                        :classTextarea="(isDisabled) ? 'no-drop' : ''" 
                                        required
                                        showIconRequired
                                        :disabled="isDisabled" 
                                        :showClassDisabled="false" 
                                        v-model="CaseObj.feedback_detail">
                                    </gofix-form-input-textarea>
                                </b-col>
                                <b-col md="4">
                                    <div class="mb-3 editPhotoValue width-full">
                                        <box-photo
                                            :attachments="CaseObj.attachments"
                                            :limit-photo="modals.photo.limitPhoto"
                                            slot-value="before_value"
                                            class-slot-value="text-right pr-15 mb-15"
                                            class-btn="pd-0"
                                            class-list="max-width-per-100"
                                            :is-slot-after="true"
                                            :open="modals.photo.open"
                                            v-model="modals.photo.open"
                                            :loading="modals.photo.loading"
                                            :is-reset-data="is_reset"
                                            :editing="!isDisabled"
                                            @upload-photo="updateDataPhoto">
                                        </box-photo>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="8">
                            <gofix-form-input-textarea 
                                label="Deliverables" 
                                :class="['caseDescTextArea', { 'form-input--error': $v.CaseObj.deliverables.$error }]" 
                                :classTextarea="(isDisabled) ? 'no-drop' : ''" 
                                required
                                showIconRequired
                                :disabled="isDisabled" 
                                :showClassDisabled="false" 
                                v-model="CaseObj.deliverables">
                            </gofix-form-input-textarea>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'
    import moment from 'moment';
    const ModalProperties = () => import("./modals/ModalProperties")
    const ModalServiceCategory = () => import("./modals/ModalServiceCategory")
    const ModalAvenueOfFeedback = () => import("./modals/ModalAvenueOfFeedback")
    const ModalNatureOfFeedback = () => import("./modals/ModalNatureOfFeedback")
    const BoxPhoto = () => import('@/views/plugins/BoxPhoto.vue')
    
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500);
    };
    export default {
        components: {
            ModalProperties,
            ModalServiceCategory,
            ModalAvenueOfFeedback,
            ModalNatureOfFeedback,
            BoxPhoto
        },
        data() {
            return {
                CaseObj: {
                    id: 0,
                    contract: null,
                    properties: null,
                    recorded_by: { 
                        email: null, 
                        name: null, 
                        phone: null 
                    },
                    reported_date: null,
                    reported_time: null,
                    recorded_date: null,
                    recorded_time: null,
                    recorded_date_time: null,
                    location: null,
                    service_categories: null,
                    equipment: [],
                    feedback_detail: null,
                    sla: null,
                    user: null,
                    work_order_id: null,
                    proposed_timeline: null,
                    other_locations: null,
                    deliverables: null,
                    status: null,
                    avenue_of_feedback: null,
                    nature_feedback: null,
                    attachments: []
                },
                loading: {
                    properties: false,
                    service_category: false,
                    priority: false,
                    nature_feedback: false
                },
                options: {
                    contracts: [],
                    properties: [],
                    service_categories: [],
                    priority: [],
                    users: [],
                    avenue_of_feedbacks: [
                        { reference_value_text: 'Hot Button', reference_value_abbr: null },
                        { reference_value_text: 'Estate Spot Check', reference_value_abbr: null }
                    ],
                    tree_nature_feedBack: []
                },
                timer: {
                    contracts: null,
                    properties: null,
                    users: []
                },
                modals: {
                    properties: {
                        open: false
                    },
                    location: {
                        open: false
                    },
                    service_category: {
                        open: false,
                        service_id: 0
                    },
                    avenue_of_feedback: {
                        open: false,
                    },
                    nauture_of_feedback: {
                        open: false,
                    },
                    photo: {
                        open: false,
                        loading: false,
                        attachments: [],
                        modal_attachments: [],
                        attachment_del_ids: [],
                        limitPhoto: 20
                    },
                },
                key_search_property: null,
                normalizerNatureFeedBack(node) {
                    if (node.data.isBatch)
                        return {
                            id: node.data.id,
                            label: node.text,
                            children: node.children
                        };
                    return {
                        id: node.data.id,
                        label: node.name,
                        children: undefined
                    };
                },
                is_default_person: false,
                is_reset: false
            }
        },
        mixins: [validationMixin],
        validations: {
            CaseObj: {
                contract: { required },
                properties: { required },
                reported_date: { required },
                reported_time: { required },
                location: { required },
                service_categories: { required },
                feedback_detail: { required },
                deliverables: { required },
                proposed_timeline: { required },
                sla: { required },
                user: { required },
                avenue_of_feedback: { required },
                nature_feedback: { required },
            },
        },
        filters: {
            highlightNode(val, option_selected) {
                if(option_selected) {
                    if(option_selected.name) {
                        val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                    } else {
                        let regex = new RegExp(option_selected, "i");
                        let index = val.search(regex);
                        let substr = val.substr(index, option_selected.length);
                        val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                    }
                }

                return val;
            },
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                ClientContractID: 'ContractController/ClientContractID',
                Item: "CaseHotButtonController/Item",
            }),
            isDisabled() {
                if(this.CaseObj.status == 'Closed' || this.CaseObj.status === 'Cancelled') return true
                return false
            }
        },
        watch: {
            Item: function(val) {
                this.loadData(val);
            },
            ClientContractID: function(val) {
                if(this.$route.params.id == "0") {
                    if(val && val.hasOwnProperty('id') && val.case_setting_module == 'Generic') {
                        this.$router.push({
                            name: 'case-detail',
                            params: {
                                id: 0
                            }
                        })
                        return
                    }
                    this.CaseObj.contract = val;
                    this.changeContract(val)
                    this.CaseObj.properties = this.CaseObj.location = this.CaseObj.service_categories = this.CaseObj.sla = null
                    this.loadRootServiceCategory()
                }
            },
            UserLogin: function() {
                this.setValueAvenue()
            },
            "options.users": function(val) {
                if(!this.is_default_person) return
                if(!val || !val.length) {
                    this.CaseObj.user = null
                    return
                }
                this.CaseObj.user = val[0]
                this.is_default_person = false
            }
        },
        updated() {
            this.$nextTick(() => {
                if(this.$refs.goFixTab)
                    this.$refs.goFixTab.handleResize();
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            if(this.Item || !this.Item.id) this.loadData();
            this.loadSLAByServiceCate();
        },
        methods: {
            validateWhenSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    if(!this.CaseObj.user){
                        this.$alertNotification("Either Team of Officer-in-charge must be assigned", "danger");
                    }else{
                        this.$alertNotification("Please enter in all the fields", "danger");
                    }
                    return false
                }

                if(this.CaseObj.contract && this.CaseObj.contract.case_hot_button_settings && this.CaseObj.contract.case_hot_button_settings.require_user_to_select_the_last_node_of_service_category && this.CaseObj.service_categories.isBatch) {
                    this.$alertNotification("You are required to select the last level of Service Category", "danger");
                    return false
                }

                return true
            },
            /* --- Load Data --- */
            async loadData(){
                this.is_reset = this.is_default_person = false
                // Get data options
                this.getContracts();
                
                if (this.Item && this.Item.id) {
                    this.CaseObj = Object.assign(this.CaseObj, {
                        ...this.Item,
                        reported_date: moment(this.Item.reported_time).toDate(),
                        reported_time: moment(this.Item.reported_time).format("HH:mm"),
                        recorded_date: moment(this.Item.recorded_time).format("DD.MM.YYYY"),
                        recorded_date_time: moment(this.Item.recorded_time).format("HH:mm"),
                        proposed_timeline: moment(this.Item.proposed_timeline).toDate(),
                    })

                    if(this.CaseObj.user) {
                        this.CaseObj.user = Object.assign(this.CaseObj.user, {
                            user_id: this.CaseObj.user.id,
                            user_name: this.CaseObj.user.name,
                            role_name: this.CaseObj.user.roles[0].name,
                            user_team: this.CaseObj.user.user_team,
                        })
                    }
                    if(this.CaseObj.avenue_of_feedback) {
                        this.CaseObj.avenue_of_feedback = {
                            reference_value_text: this.CaseObj.avenue_of_feedback,
                            reference_value_abbr: null
                        }
                    }
                    this.is_reset = true
                } else {
                    this.CaseObj = Object.assign(this.CaseObj, {
                        id: 0,
                        contract: null,
                        properties: null,
                        recorded_by: { 
                            email: null, 
                            name: null, 
                            phone: null 
                        },
                        reported_date: null,
                        reported_time: null,
                        recorded_date: null,
                        recorded_date_time: null,
                        location: null,
                        service_categories: null,
                        equipment: [],
                        feedback_detail: null,
                        sla: null,
                        user: null,
                        work_order_id: null,
                        proposed_timeline: null,
                        other_locations: null,
                        deliverables: null,
                        status: null,
                        avenue_of_feedback: null,
                        nature_feedback: null
                    });
                    this.CaseObj.recorded_by = this.UserLogin
                    this.CaseObj.reported_date = moment().toDate();
                    this.CaseObj.reported_time = moment().format("HH:mm");
                    this.CaseObj.recorded_date = moment().format("DD.MM.YYYY");
                    this.CaseObj.recorded_date_time = moment().format("HH:mm");
                    if(this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) {
                        this.CaseObj.contract = this.ClientContractID;
                    }

                    this.setValueAvenue()
                }
                window.addEventListener('resize', this.handleResize);
                this.handleResize();
                this.changeContract(this.CaseObj.contract, true)
                this.loadRootServiceCategory()
            },
            /* --- Contracts --- */
            async getContracts(filter = null, limit = 100) {
                let filters = {
                    case_setting_module: { type:"text", value:"Hot-Button", function:"ilike", with:[] }
                }
                if(filter) {
                    filters = Object.assign(filters, filter)
                }
                await this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filters, limit, 1])
                    .then(response => {
                        this.options.contracts = response.data;
                    })
            },
            searchContract(search, loading) {
                this.options.contracts = []
                loading(true);
                if (this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer.contracts = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: { type:"text", value: search, function:"ilike", with:[] } }, 1000)
                        await loading(false)
                    } catch(err) {
                        loading(false)
                    }
                }, 500);
            },
            changeContract(val, isLoad = false) {
                this.loadFmStaff()
                this.searchProperty('', () => {})
                this.loadRootNatureFeedBack();
                if(!isLoad || this.$route.params.id == "0") {
                    this.CaseObj.properties = this.CaseObj.location = this.CaseObj.service_categories = this.CaseObj.sla = null
                    this.CaseObj.user = null
                }
            },
            /* --- Properties --- */
            searchProperty(search, loading) {
                this.options.properties = []
                if(!this.CaseObj.contract || !this.CaseObj.contract.property_root_id) return

                loading(true);
                this.loading.properties = true;
                if (this.timer.properties) {
                    clearTimeout(this.timer.properties);
                    this.timer.properties = null;
                }
                this.timer.properties = setTimeout(() => {
                    this.key_search_property = search;
                    this.$store.dispatch('PropertyController/getSearchProperties', {
                            keyword: search,
                            property_root_id: this.CaseObj.contract.property_root_id,
                            parent_id: this.CaseObj.contract.property_root_id,
                            limit: 100,
                        })
                        .then(response => {
                            this.options.properties = response
                            this.loading.properties = false;
                            loading(false);
                        })
                        .catch(err => {
                            loading(false);
                            this.loading.properties = false;
                        })
                }, 500);
            },
            changeProperty(val) {
                this.loadFmStaff();
                // this.CaseObj.location = val;
                // this.modals.properties.root_path = (val && val.root_path) ? val.root_path : null;
            },
            showModalPrimaryLocation() {
                if(!this.CaseObj.properties) {
                    return this.$alertNotification("Please select division", "danger");
                }
                this.modals.location.open = true
            },
            /* --- Update data from modal component --- */
            updateProperty(val) {
                this.CaseObj.properties = val
            },
            updateLocation(val) {
                this.CaseObj.location = val
            },
            updateServiceCategory(val) {
                this.CaseObj.service_categories = val
            },
            /* --- Service Category --- */
            getServiceCategory(service_category_root_id, contract_id) {
                return new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${contract_id}/tree-service-categories/${service_category_root_id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(response => {
                            if(response.data.data[0] && response.data.data[0].children && response.data.data[0].children.length) {
                                let arrTmp = response.data.data[0].children.filter(item => item.name.toLowerCase() == this.CaseObj.avenue_of_feedback.reference_value_text.toLowerCase());
                                if(arrTmp.length) {
                                    this.modals.service_category.service_id = arrTmp[0].id
                                    resolve(arrTmp)
                                    return
                                }
                                resolve([])
                            } else {
                                resolve(response.data.data)
                            }
                        }).catch(error => {});
                });
            },
            async loadRootServiceCategory() {
                this.options.service_categories = []
                if(!this.CaseObj.contract || !this.CaseObj.avenue_of_feedback) return
                try {
                    this.loading.service_category = true;
                    let result = await this.getServiceCategory(0, this.CaseObj.contract.id);
                    if(result.length) {
                        this.options.service_categories = await this.getServiceCategory(result[0].id, this.CaseObj.contract.id);
                    }
                    this.loading.service_category = await false;
                } catch(err) {
                    this.loading.service_category = false;
                }
            },
            loadOptionServiceCategory({
                action,
                parentNode,
                callback
            }) {
                simulateAsyncOperation(async () => {
                    parentNode.children = await this.getServiceCategory(parentNode.data.id, this.CaseObj.contract.id)
                    callback()
                })
            },
             /* --- SLA --- */
            loadSLAByServiceCate() {
                this.loading.priority = true
                this.$store.dispatch("v2SlaController/getSlaList", {
                    limit: -1,
                    page: 1,
                    filter: { contract_id : -2 },
                }).then(response => {
                    this.loading.priority = false;
                    this.options.priority = response.items;
                });
            },
            loadFmStaff() {
                this.options.users = []
                if (!this.CaseObj.contract || !this.CaseObj.avenue_of_feedback) {
                    return;
                }
                this.loading.users = true
                if (this.timer.users) {
                    clearTimeout(this.timer.users);
                    this.timer.users = null;
                }
                this.timer.users = setTimeout(() => {
                    this.$store.dispatch("v2UserController/getAccessFmUsers", {
                            contract_id: this.CaseObj.contract.id,
                            property_id: this.CaseObj.location ? this.CaseObj.location.id : null,
                            service_category_id: this.CaseObj.service_categories ? this.CaseObj.service_categories.id : null,
                            section_name: ["Case Management"],
                            module_name: ["Case"],
                            filter: {
                                avenue_of_feedback:  this.CaseObj.avenue_of_feedback.reference_value_text
                            }
                        })
                        .then(response => {
                            this.options.users = response.items;
                            this.loading.fm_staff = false;
                        })
                        .catch(err => {
                            this.loading.fm_staff = false
                        })
                }, 500);
            },
            searchFmStaff(search, loading) {
                loading(true);
                this.loading.users = true
                if (this.timer.users) {
                    clearTimeout(this.timer.users);
                    this.timer.users = null;
                }
                this.timer.users = setTimeout(() => {
                    this.$store.dispatch("v2UserController/getAccessFmUsers", {
                            contract_id: this.CaseObj.contract.id,
                            property_id: this.CaseObj.location ? this.CaseObj.location.id : null,
                            service_category_id: this.CaseObj.service_categories ? this.CaseObj.service_categories.id : null,
                            section_name: ["Case Management"],
                            module_name: ["Case"],
                            filter: {
                                name: search || null,
                                filter: {
                                    role_name:  this.CaseObj.avenue_of_feedback.reference_value_text == 'Hot Button' ? 'Hot Button Officer' : 'Estate Spot Check Officer'
                                }
                            }
                        })
                        .then(response => {
                            this.options.users = response.items;
                            this.loading.fm_staff = false;
                            loading(false);
                        })
                        .catch(err => {
                            this.loading.fm_staff = false
                            loading(false);
                        })
                }, 500);
            },
            updateAvenueOfFeedback(val) {
                this.CaseObj.avenue_of_feedback = val
            },
            loadRootNatureFeedBack() {
                if(!this.CaseObj.contract || !this.CaseObj.contract.id) return;
                this.loading.nature_feedback = true;
                global.axios(`api/contracts/${this.CaseObj.contract.id}/tree-nature-feedback/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        this.options.tree_nature_feedBack = response.data.data;
                        this.loading.nature_feedback = false;

                    }).catch(error => {});
            },
            getNatureFeedBack(nature_feedback_root_id, contract_id) {
                return new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${contract_id}/tree-nature-feedback/${nature_feedback_root_id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(response => {
                            resolve(response.data.data)
                        }).catch(error => {});
                });
            },
            loadOptionNatureFeedBack({
                action,
                parentNode,
                callback
            }) {
                simulateAsyncOperation(async () => {
                    parentNode.children = await this.getNatureFeedBack(parentNode.data.id, this.CaseCreateObj.contract.id)
                    callback()
                })
            },
            updateNature(val) {
                if(val && val.data)
                    this.CaseObj.nature_feedback = val
            },
            /*-- Photo ----------------------------------------------------------*/
            handleResize() {
                this.modals.photo.limitPhoto = 9
                if (window.innerWidth < 1500) {
                    this.modals.photo.limitPhoto = 14
                }
                if (window.innerWidth >= 1500 && window.innerWidth < 1920) {
                    this.modals.photo.limitPhoto = 16
                }
            },
            updateDataPhoto(data) {
                this.modals.photo.attachments        = data.attachments;
                this.modals.photo.attachment_del_ids = data.attachment_del_ids;
                this.modals.photo.modal_attachments  = data.modal_attachments;
                this.uploadPhotos();
            },
            async uploadPhotos(showMsg = 1, caseId = null) {
                if(caseId) this.CaseObj.id = caseId
                if (!this.CaseObj.id) {
                    this.CaseObj.attachments = this.modals.photo.modal_attachments;
                    this.modals.photo.open = false;
                    return;
                }

                this.modals.photo.loading = true;
                if(this.modals.photo.attachment_del_ids.length > 0) {
                    await this.$store.dispatch("AttachmentController/removeAttachments", {
                        ids: this.modals.photo.attachment_del_ids
                    })
                }

                await this.$store.dispatch("AttachmentController/createAttachmentWithType", {
                    id: this.CaseObj.id,
                    attachments: this.modals.photo.attachments,
                    type: 'cases'
                })
                .then(response => {
                    this.modals.photo.loading = false;
                    this.modals.photo.open = false;
                    if (showMsg) {
                        this.$alertNotification(this.$notificationV2('adding', 'attachment'));
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.modals.photo.loading = false;
                });

                if(!caseId) {
                    this.$emit("resetData");
                }
            },
            setValueAvenue() {
                if(this.UserLogin && this.UserLogin.roles) {
                    let filters = this.UserLogin.roles.filter(item => ['Hot Button Officer', 'Estate Spot Check Officer'].includes(item.name));
                    if(filters.length == 1) {
                        let value = { reference_value_text: 'Hot Button', reference_value_abbr: null }
                        if(filters[0].name == 'Estate Spot Check Officer') value.reference_value_text = 'Estate Spot Check'
                        this.CaseObj.avenue_of_feedback = value
                        this.is_default_person = true
                    }
                }
            },
            changeAvenueOfFeedback() {
                this.is_default_person = true
                this.loadFmStaff()
                this.CaseObj.service_categories = null
                this.loadRootServiceCategory()
            },
            normalizerServiceCategory(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    };

                return {
                    id: node.data.id,
                    label: node.name,
                    children: undefined,
                    isDisabled: this.modals.service_category.service_id == node.parent_id ? true : false
                };
            },
            changeService() {
                this.is_default_person = true
                this.loadFmStaff();
            },
        }
    }
</script>